import React from 'react'
import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { AiGradientDefs } from './AiGradientDefs'
import {
  ToolbarButton,
  ToolbarIcon,
  ToolbarLabel,
} from './AiEvaluationToolbarButton.styled'

interface Props {
  onClick: () => void
  disabled?: boolean
}

export const AiEvaluationToolbarButton: React.FC<Props> = ({
  onClick,
  disabled,
}) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation',
  })

  return (
    <ToolbarButton
      type="button"
      data-test-id="button-ai-evaluation-open"
      $disabled={disabled}
      onClick={onClick}
      disabled={disabled}
    >
      <AiGradientDefs />
      <ToolbarIcon icon={faSparkles} $disabled={disabled} />
      <ToolbarLabel $disabled={disabled}>
        {t('toolbar.generateWithAiLabel')}
      </ToolbarLabel>
    </ToolbarButton>
  )
}

export default AiEvaluationToolbarButton
